import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAsyncGetSalesInvoiceModule } from "redux/salesInvoiceModuleSlice";


const useSalesInvoiceModule = () => {

  const [loading, setLoading] = useState(true); 
  const salesModule = useSelector((state) => state.salesModule);

  const dispatch = useDispatch();

  useEffect(() => {
    (async()=>{
      setLoading(true);
      await dispatch(fetchAsyncGetSalesInvoiceModule());
      setLoading(false); 
    })()

  }, [dispatch]);

 
  return { 
    salesModule,
    loading,
    setLoading
   };
};

export default useSalesInvoiceModule;
